module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.com_name))])]), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.com_name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-12"
  }, [_c('div', {
    staticClass: "store_contact"
  }, [_c('figure', {
    staticClass: "pic pull-left text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": 'https://files.i80.com.tw/images/product/' + _vm.rowData.com_resize_image
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "lcass": "tel"
    }
  }, [_vm._v("電話：" + _vm._s(_vm.rowData.com_phone))]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("地址：" + _vm._s(_vm.rowData.county_name) + _vm._s(_vm.rowData.district_name) + _vm._s(_vm.rowData.com_address))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rowData.c_website != ''),
      expression: "rowData.c_website!=''"
    }],
    staticClass: "website"
  }, [_vm._v("\n                網址："), _c('a', {
    attrs: {
      "href": _vm.rowData.c_website,
      "target": "_blink"
    }
  }, [_vm._v("點我進入網站")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-sm-9 col-xs-12",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('p', {
    staticClass: "edit"
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.website_intro)
    }
  }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "navbar-form navbar-right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categorySelected),
      expression: "categorySelected"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.categorySelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.category), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "關鍵字"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.ProductSearch()
      }
    }
  }, [_vm._v("查詢")])]), _vm._v(" "), _c('div', {
    staticClass: "row clear"
  }, [_c('paginate', {
    staticClass: "paginate-langs",
    attrs: {
      "name": "products",
      "list": _vm.products,
      "per": 12,
      "tag": "div"
    }
  }, _vm._l((_vm.paginated('products')), function(item) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/product/' + item.id + '/' + _vm.rowData.m_factoryID + '/' + _vm.userID
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])], 1), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.rowData.point > 0) ? _c('p', {
      staticClass: "points"
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-gift",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.point) + "點")]) : _vm._e(), _vm._v(" "), (_vm.rowData.price > 0) ? _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e(), _vm._v(" "), (_vm.rowData.balance >= item.price && _vm.rowData.com_shopping == 'Y') ? _c('button', {
      staticClass: "addcart btn btn-default i80_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.ADD_TO_CART(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-shopping-cart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 加入購物車\n      ")]) : _vm._e()])])
  }))], 1), _vm._v(" "), _c('center', [_c('nav', {
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('paginate-links', {
    attrs: {
      "for": "products",
      "classes": {
        'ul': ['pagination', 'pagination-sm'],
        'li': 'page-item'
      }
    }
  })], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("聯盟店家")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d76a62d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoreView.vue
// module id = 311
// module chunks = 1